/**
 * Centralized site configuration — single source of truth for
 * values previously hardcoded across multiple components.
 */

export const SITE_CONFIG = {
  name: 'RurayHUB',
  company: 'Ruray Digital',
  url: 'https://ruraydigital.com',
  email: 'contacto@ruraydigital.com',
  supportEmail: 'support@ruraydigital.com',
  whatsapp: {
    number: '593987119183',
    defaultMessage: 'Hola, me interesa una demo de RurayHUB 👋',
    demoMessage: 'Hola, quiero agendar una demo de 15 min de RurayHUB',
  },
  calcom: {
    user: 'ronny-amores-ufwdxp',
    event: 'demo-15min',
  },
  pricing: {
    proMonthly: 200,
    setupFee: 250,
    currency: 'USD',
  },
} as const;

export const waLink = (msg?: string) => {
  const message = msg || SITE_CONFIG.whatsapp.defaultMessage;
  return `https://wa.me/${SITE_CONFIG.whatsapp.number}?text=${encodeURIComponent(message)}`;
};

// `?lang=es` fuerza el idioma del booker de Cal.com a español — si no,
// cae al idioma del navegador del visitante (a menudo inglés).
export const calLink = () =>
  `${SITE_CONFIG.calcom.user}/${SITE_CONFIG.calcom.event}?lang=es`;

/**
 * Tema del embed de Cal.com, alineado a la paleta real del sitio
 * (fondo negro puro, texto blanco, bordes translúcidos) en vez de
 * solo el color de marca. Cal.com siempre se muestra en dark aquí,
 * independiente del tema claro/oscuro del sitio.
 *
 * `cal-bg-emphasis` es el que pinta las cajitas de "día disponible" del
 * calendario — se dejó casi fundido con el fondo negro a propósito (look
 * minimalista pedido explícitamente), para que solo el día seleccionado
 * (cal-brand, teal) y el texto llamen la atención.
 */
export const CAL_UI_CONFIG = {
  theme: 'dark' as const,
  cssVarsPerTheme: {
    dark: {
      'cal-brand': '#00e5d1',
      'cal-text': '#ffffff',
      'cal-text-emphasis': '#ffffff',
      'cal-text-muted': '#9ca3af',
      'cal-bg-emphasis': '#141414',
      'cal-border': '#1f1f1f',
      'cal-border-emphasis': '#2a2a2a',
      'cal-border-subtle': '#181818',
      'cal-border-booker': '#1f1f1f',
    },
    light: {
      'cal-brand': '#00e5d1',
    },
  },
};
